<template>
  <button
    class="control-button"
    @click="emit('click')"
    :disabled="disabled"
    :aria-label="t('player.controls.nextVideo')"
    :data-tooltip="t('player.controls.nextVideo') + ' (n)'"
    v-html="skipNextIcon"
  />
</template>

<script setup lang="ts">
import { skipNextIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

defineProps<{
  disabled: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
